import parse from "html-react-parser";

const GeneralSection = ({ data }) => {
  return (
    <div className="general__section">
      <p className="section__title">{data?.value?.section_title}</p>
      {data?.value?.content?.map((con, index) => {
        return (
          <div className="section__content" key={index}>
            {parse(con.value)}
          </div>
        );
      })}
    </div>
  );
};

export default GeneralSection;
